export default __webpack_public_path__ + "static/media/telegram.b7074886.svg";